import { render, staticRenderFns } from "./hl-Siders.vue?vue&type=template&id=fee79280"
import script from "./hl-Siders.vue?vue&type=script&lang=js"
export * from "./hl-Siders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports